import api from 'services/api/microfwk';
import _ from 'lodash';

export const getPlanOffers = (params = {}) =>
  api
    .get('/services/plans/v1/offers', {
      params: {
        ...params,
        user_token: JSON.parse(
          localStorage.getItem('loginInfo.logged_user_data'),
        )?.token,
      },
    })
    .then(({ data }) => {
      const status = _.get(data, 'status', _.get(data, 'response.status', 0));
      if (parseInt(status, 10) !== 200) {
        const error = _.get(data, 'response', data);
        return error !== null ? error : data;
      }
      return data.response;
    });
